import Icon from '../../../components/AppIcon';

const ApplicationRequirements = ({ requirements }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 lg:p-8">
      <h2 className="text-2xl font-bold text-foreground mb-6 flex items-center gap-2">
        <Icon name="ClipboardList" size={24} className="text-primary" />
        Application Requirements
      </h2>
      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="FileText" size={20} className="text-primary" />
            Required Documents
          </h3>
          <div className="space-y-3">
            {requirements?.documents?.map((doc, index) => (
              <div key={index} className="flex items-start gap-3 p-3 bg-muted rounded-lg">
                <Icon name="File" size={18} className="text-primary flex-shrink-0 mt-0.5" />
                <div className="flex-1">
                  <p className="text-sm font-medium text-foreground">{doc?.name}</p>
                  {doc?.description && (
                    <p className="text-xs text-muted-foreground mt-1">{doc?.description}</p>
                  )}
                </div>
                {doc?.required && (
                  <span className="text-xs font-medium text-error">Required</span>
                )}
              </div>
            ))}
          </div>
        </div>

        {requirements?.screeningProcess && requirements?.screeningProcess?.length > 0 && (
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
              <Icon name="ListChecks" size={20} className="text-primary" />
              Screening Process
            </h3>
            <div className="space-y-3">
              {requirements?.screeningProcess?.map((step, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                    <span className="text-sm font-semibold text-primary">{index + 1}</span>
                  </div>
                  <div className="flex-1 pt-1">
                    <p className="text-sm font-medium text-foreground">{step?.title}</p>
                    <p className="text-xs text-muted-foreground mt-1">{step?.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {requirements?.additionalInfo && (
          <div className="p-4 bg-primary/5 border border-primary/20 rounded-lg">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={18} className="text-primary flex-shrink-0 mt-0.5" />
              <div>
                <h4 className="text-sm font-semibold text-foreground mb-2">Additional Information</h4>
                <p className="text-sm text-muted-foreground leading-relaxed">{requirements?.additionalInfo}</p>
              </div>
            </div>
          </div>
        )}

        {requirements?.contactInfo && (
          <div className="border-t border-border pt-6">
            <h4 className="text-sm font-semibold text-foreground mb-3">Questions about this position?</h4>
            <div className="space-y-2">
              {requirements?.contactInfo?.email && (
                <a
                  href={`mailto:${requirements?.contactInfo?.email}`}
                  className="flex items-center gap-2 text-sm text-primary hover:underline"
                >
                  <Icon name="Mail" size={16} />
                  <span>{requirements?.contactInfo?.email}</span>
                </a>
              )}
              {requirements?.contactInfo?.phone && (
                <a
                  href={`tel:${requirements?.contactInfo?.phone}`}
                  className="flex items-center gap-2 text-sm text-primary hover:underline"
                >
                  <Icon name="Phone" size={16} />
                  <span>{requirements?.contactInfo?.phone}</span>
                </a>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicationRequirements;